import * as eventActionCreators from 'store/actionCreators/events';

import { eventSource } from 'sources';
import { EventParams } from 'sources/EventSource';
import { AppThunk } from 'store/store';
import { setError } from 'store/actions/app';

export const list = (params: EventParams): AppThunk => async (
  dispatch: any
): Promise<void> => {
  try {
    const results = await eventSource.List(params);
    dispatch(eventActionCreators.listSuccess(results));
  } catch (e) {
    dispatch(setError(e?.message));
  }
};

export const listAll = (params: EventParams): AppThunk => async (
  dispatch: any
): Promise<void> => {
  try {
    const results = await eventSource.ListAll(params);
    dispatch(eventActionCreators.listAllSuccess(results));
  } catch (e) {
    dispatch(setError(e?.message));
  }
};
